import reducerRegistry from './../../helpers/ReducerRegistry';
import financialAnalysisService from '../../../core/services/Fundamental/FinancialAnalysisService';
import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import priceDataService from '../../../core/services/Prices/PriceData/PriceDataService';
import { formatTextFloat } from '../../helpers/Text';
import {
  getDataFollowKeyByDot,
  checkIsBank,
  getSyncDefaultSearch,
  getQueryParams,
} from './../../helpers/Common';
import Const from './Const';
import { fetchListDataCheckup } from './tab-content/FACheckup/helper';
import { formatData } from './../../helpers/Api';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'FINANCIAL_ANALYSIS:';
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
// FR => financial Ratio
const SET_FETCHING_ZMF = `${REDUCER_NAME}SET_FETCHING_ZMF`;
// ZMF => ZMF Score
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_ZMF_SCORE = `${REDUCER_NAME}FETCH_ZMF_SCORE`;
const FETCH_FA_CHECKUP = `${REDUCER_NAME}FETCH_FA_CHECKUP`;
const CHANGE_COLUMN_COMPARING_CHECKUP = `${REDUCER_NAME}CHANGE_COLUMN_COMPARING_CHECKUP`;
const SET_CONDITION = `${REDUCER_NAME}SET_CONDITION`;
const CHANGE_TAB = `${REDUCER_NAME}CHANGE_TAB`;
const GET_TOP_CONTENT = `${REDUCER_NAME}GET_TOP_CONTENT`;
const SUBSCRIBE_REAL_TIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REAL_TIME_DATA_TICK`;
const RESET_REAL_TIME_DATA = `${REDUCER_NAME}RESET_REAL_TIME_DATA`;
const GET_COMPANY_SCORE = `${REDUCER_NAME}GET_COMPANY_SCORE`;
const SET_FA_CHECKUP_LOADING = `${REDUCER_NAME}SET_FA_CHECKUP_LOADING`;
const RESET_CHECK_UP_DATA = `${REDUCER_NAME}RESET_CHECK_UP_DATA`;

export { REDUCER_NAME, reducer as default, changeColumnComparingCheckup };

export const getCurrentCompares = componentId => {
  return (
    currentState.get(
      ConstCommon.listComponent.FADividendAnalysis,
      'currentCompares',
      componentId,
    ) || {}
  );
};

export const resetCheckUpData = componentId => ({
  type: RESET_CHECK_UP_DATA,
  payload: { componentId },
});

export const setFaCheckupLoading = (componentId, isLoading = true) => {
  return {
    type: SET_FA_CHECKUP_LOADING,
    payload: {
      componentId,
      isLoading,
    },
  };
};

export const fetchLookupItem = (position, ticker, componentId) => dispatch => {
  currentState.add(
    ConstCommon.listComponent.FADividendAnalysis,
    'currentCompares',
    {
      ...getCurrentCompares(componentId),
      [position]: ticker,
    },
    componentId,
  );
  dispatch(setFaCheckupLoading(componentId));
  const params = {
    OrganCode: ticker.organCode,
    IsLookup: true,
  };

  financialAnalysisService.getFACheckup(params).then(response => {
    const items = formatData(response);
    const data = items.length > 0 ? items[0] : {};
    dispatch({
      type: CHANGE_COLUMN_COMPARING_CHECKUP,
      payload: {
        position,
        isBanking: ticker.isBanking,
        data: data.checkupItem,
        componentId,
      },
    });
  });
};

export const setFetchingZMF = (status = true, id) => {
  return {
    type: SET_FETCHING_ZMF,
    payload: {
      zmfStatus: status,
      zmfId: id,
    },
  };
};

export const subscribeRealTimeTick = (id, data, code) => {
  return dispatch => {
    const result = data.find(bidAsk => bidAsk.organCode === code);
    if (result) {
      dispatch({
        type: SUBSCRIBE_REAL_TIME_DATA_TICK,
        payload: {
          result,
          realTimeId: id,
        },
      });
    }
  };
};

export const fetchCompanyScore = (id, code) => {
  return dispatch => {
    snapShotService.getCompanyScore({ OrganCode: code }).then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_COMPANY_SCORE,
        payload: {
          companyScoreId: id,
          companyScore: items && items[0] ? items[0] : {},
        },
      });
    });
  };
};

export const fetchInfoTicker = (id, code) => {
  return dispatch => {
    priceDataService.getLatestPrice({ Code: code }).then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_TOP_CONTENT,
        payload: {
          topContentId: id,
          topContent: items && items.length ? items[0] : {},
        },
      });
    });
  };
};

export const fetchZMFScore = (id, params) => dispatch => {
  dispatch(setFetchingZMF(true, id));
  financialAnalysisService.getZMFScore(params).then(response => {
    const { items = [] } = response;
    dispatch({
      type: FETCH_ZMF_SCORE,
      payload: {
        ZMFDataId: id,
        ZMFScoreData: items && items.length ? items[0] : {},
      },
    });
  });
};

function changeColumnComparingCheckup(params, isBanking, componentId) {
  return {
    type: CHANGE_COLUMN_COMPARING_CHECKUP,
    payload: {
      changeColumnCompare: params,
      isBanking,
      componentId,
    },
  };
}

export const fetchFACheckup = (componentId, params, isBanking) => dispatch => {
  dispatch(setFaCheckupLoading(componentId));
  financialAnalysisService.getFACheckup(params).then(response => {
    const items = formatData(response);
    const data = items.length > 0 ? items[0] : {};

    dispatch({
      type: FETCH_FA_CHECKUP,
      payload: {
        componentId,
        isBanking,
        data,
      },
    });
  });
};

export const setCondition = (id, value) => {
  const { code, comTypeCode } = value;
  return (dispatch, getState) => {
    dispatch({
      type: SET_CONDITION,
      payload: {
        conditionId: id,
        searchParams: value,
      },
    });

    dispatch(fetchInfoTicker(id, code));
    dispatch(fetchCompanyScore(id, code));
    const currentTab = getState()[REDUCER_NAME].listMultiComponent[id]
      .currentTab;

    if (currentTab === 1) {
      dispatch(
        fetchFACheckup(id, { OrganCode: code }, checkIsBank(comTypeCode)),
      );
    }
    if (currentTab === 3) {
      dispatch(fetchZMFScore(id, { OrganCode: code }));
    }

    dispatch({
      type: RESET_REAL_TIME_DATA,
      payload: {
        reaTimeResetId: id,
      },
    });
  };
};

export const changeTab = (componentId, tabNumber) => {
  return dispatch => {
    console.log(tabNumber, componentId);
    dispatch({
      type: CHANGE_TAB,
      payload: {
        tabNumber,
        componentId,
      },
    });
  };
};

const initialState = {
  listMultiComponent: {},
};

function getCurrentTab() {
  const mapTab = {
    FaCheckup: 1,
    ZmfScore: 3,
  };

  return mapTab[getQueryParams('tab')];
}

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const dataId = action.payload.id;
      const initCode = action.payload.dragCode;
      let defaultSearchParams = {
        displayCode: 'AAA',
        code: 'AAA',
        isBanking: false,
      };
      if (initCode) {
        defaultSearchParams = {
          displayCode: initCode.ticker,
          code: initCode.organCode,
          isBanking: checkIsBank(initCode.comTypeCode),
        };
      }
      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            currentTab:
              getCurrentTab() ||
              currentState.get(
                ConstCommon.listComponent.FinancialAnalysis,
                'currentTab',
                dataId,
              ) ||
              1,
            faCheckupData: {
              listColumnTable: [],
              listFaCheckupByTicker: {},
              listTickerFACheckup: [],
              listLookupItems: [],
              yearReport: '',
              listDataCheckup: {},
              isLoading: true,
            },
            ZMFScoreData: {},
            financialRatioData: {
              ratioYears: [],
            },
            topContent: {},
            topContentRealTime: {},
            companyScore: {},
            searchParams:
              currentState.get(
                ConstCommon.listComponent.FinancialAnalysis,
                'searchParams',
                dataId,
              ) ||
              getSyncDefaultSearch(
                ConstCommon.listComponent.FinancialAnalysis,
                true,
              ) ||
              defaultSearchParams,
            isFetching: true,
          },
        },
      };

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case GET_COMPANY_SCORE:
      const { companyScore, companyScoreId } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [companyScoreId]: {
            ...state.listMultiComponent[companyScoreId],
            companyScore,
          },
        },
      };

    case SUBSCRIBE_REAL_TIME_DATA_TICK:
      const { result, realTimeId } = action.payload;
      const topContentRealTime = {
        MatchPrice: getDataFollowKeyByDot(
          result,
          Const.realTimeData.MATCH_PRICE,
        ),
        PriceChange: getDataFollowKeyByDot(
          result,
          Const.realTimeData.PRICE_CHANGE,
        ),
        PercentPriceChange: getDataFollowKeyByDot(
          result,
          Const.realTimeData.PERCENT_PRICE_CHANGE,
        ),
        ReferencePrice: getDataFollowKeyByDot(
          result,
          Const.realTimeData.REFERENCE_PRICE,
        ),
        CeilingPrice: getDataFollowKeyByDot(
          result,
          Const.realTimeData.CEILING_PRICE,
        ),
        FloorPrice: getDataFollowKeyByDot(
          result,
          Const.realTimeData.FLOOR_PRICE,
        ),
        TradingDate: getDataFollowKeyByDot(
          result,
          Const.realTimeData.TRADING_DATE,
        ),
      };

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [realTimeId]: {
            ...state.listMultiComponent[realTimeId],
            topContentRealTime,
          },
        },
      };

    case RESET_REAL_TIME_DATA:
      const { reaTimeResetId } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [reaTimeResetId]: {
            ...state.listMultiComponent[reaTimeResetId],
            topContentRealTime: {},
          },
        },
      };

    case CHANGE_TAB: {
      const { tabNumber, componentId } = action.payload;
      currentState.add(
        ConstCommon.listComponent.FinancialAnalysis,
        'currentTab',
        tabNumber,
        componentId,
      );

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            currentTab: tabNumber,
          },
        },
      };
    }

    case GET_TOP_CONTENT:
      const {
        topContent: { priceInfo },
        topContentId,
      } = action.payload;
      const MatchPrice = priceInfo ? priceInfo.matchPrice : null;
      const PriceChange = priceInfo ? priceInfo.priceChange : null;
      const PercentPriceChange = priceInfo
        ? priceInfo.percentPriceChange
        : null;
      const ReferencePrice = priceInfo ? priceInfo.referencePrice : null;

      const CeilingPrice = priceInfo ? priceInfo.ceilingPrice : null;
      const FloorPrice = priceInfo ? priceInfo.floorPrice : null;

      const topContent = {
        MatchPrice,
        PriceChange,
        PercentPriceChange,
        ReferencePrice,
        CeilingPrice,
        FloorPrice,
      };

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [topContentId]: {
            ...state.listMultiComponent[topContentId],
            topContent,
          },
        },
      };

    case FETCH_ZMF_SCORE:
      const {
        ZMFScoreData: { scorings = [] },
        ZMFDataId,
      } = action.payload;

      const zData = scorings
        .map(item => {
          return {
            y: item.yearReport,
            x: item.zScore,
            title: formatTextFloat(item.zScore),
          };
        })
        .sort((a, b) => a.y - b.y);

      const mData = scorings
        .map(item => {
          return {
            y: item.yearReport,
            x: item.mScore,
            title: formatTextFloat(item.mScore),
          };
        })
        .sort((a, b) => a.y - b.y);

      const fData = scorings
        .map(item => {
          return {
            y: item.yearReport,
            x: item.fScore,
            title: formatTextFloat(item.fScore),
          };
        })
        .sort((a, b) => a.y - b.y);

      const ZMFScoreData = {
        zData,
        mData,
        fData,
        isLoading: false,
      };

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [ZMFDataId]: {
            ...state.listMultiComponent[ZMFDataId],
            ZMFScoreData,
          },
        },
      };

    case SET_FETCHING_ZMF:
      const { zmfId, zmfStatus } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [zmfId]: {
            ...state.listMultiComponent[zmfId],
            ZMFScoreData: {
              ...state.listMultiComponent[zmfId].ZMFScoreData,
              isLoading: zmfStatus,
            },
          },
        },
      };

    case SET_FA_CHECKUP_LOADING:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            faCheckupData: {
              ...state.listMultiComponent[action.payload.componentId]
                .faCheckupData,
              isLoading: action.payload.isLoading,
            },
          },
        },
      };

    case CHANGE_COLUMN_COMPARING_CHECKUP: {
      const { position, isBanking, data, componentId } = action.payload;
      const positionCompareItem = position;
      const { listDataCheckup } = {
        ...state.listMultiComponent[componentId].faCheckupData,
      };

      listDataCheckup.comparingCheckupItems.forEach((item, index) => {
        if (+index === +positionCompareItem) {
          listDataCheckup.comparingCheckupItems[index] = data;
        }
      });

      const {
        listColumnTable,
        listFaCheckupByTicker,
        listTickerFACheckup,
        listLookupItems,
        yearReport,
      } = fetchListDataCheckup(listDataCheckup, isBanking);
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            faCheckupData: {
              ...state.listMultiComponent[componentId].faCheckupData,
              listColumnTable,
              listFaCheckupByTicker,
              listTickerFACheckup,
              listLookupItems,
              yearReport,
              isLoading: false,
            },
          },
        },
      };
    }

    case FETCH_FA_CHECKUP:
      const { componentId, isBanking, data: listDataCheckup } = action.payload;
      const {
        listColumnTable,
        listFaCheckupByTicker,
        listTickerFACheckup,
        listLookupItems,
        yearReport,
      } = fetchListDataCheckup(listDataCheckup, isBanking);

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            faCheckupData: {
              ...state.listMultiComponent[componentId].faCheckupData,
              listColumnTable,
              listFaCheckupByTicker,
              listTickerFACheckup,
              listLookupItems,
              yearReport,
              listDataCheckup,
              isLoading: false,
            },
          },
        },
      };

    case SET_CONDITION: {
      const { searchParams, conditionId } = action.payload;

      const { code, displayCode, isBanking } = searchParams;

      currentState.add(
        ConstCommon.listComponent.FinancialAnalysis,
        'searchParams',
        { code, displayCode, isBanking },
        conditionId,
      );

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [conditionId]: {
            ...state.listMultiComponent[conditionId],
            searchParams,
          },
        },
      };
    }

    case CHANGE_SIZE_COMPONENT:
      const { width, height } = action.payload;
      const componentSizeId = action.payload.id;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentSizeId]: {
            ...state.listMultiComponent[componentSizeId],
            component: {
              width,
              height,
            },
          },
        },
        component: action.payload,
      };
    case RESET_CHECK_UP_DATA:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            faCheckupData: {
              listColumnTable: [],
              listFaCheckupByTicker: {},
              listTickerFACheckup: [],
              listLookupItems: [],
              yearReport: '',
              listDataCheckup: {},
              isLoading: true,
            },
          },
        },
      };
    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
